import { HealthInsureSettingPanelComponent } from './HealthInsureSetting/HealthInsureSettingPanelComponent';
import { PasswordResettingPanelComponent } from './PasswordResetting/PasswordResettingPanelComponent';

import { Component, ViewChild, ViewContainerRef } from '@angular/core';
import { AppViewReceiverConst } from 'src/app/Util/AppReceiver/AppViewReceiverConst';
import { AppViewReceiverModel } from 'src/app/Util/AppReceiver/AppViewReceiverModel';
import { BaseFragment } from 'src/app/View/BaseUI/BaseFragment';
import { SocialLinkSettingPanelComponent } from './SocialLinkSetting/SocialLinkSettingPanelComponent';
import { UserInfoPanelComponent } from './UserInfo/UserInfoPanelComponent';
import { AppSingletonUtil } from 'src/app/Util/AppSingletonUtil';

@Component({
	selector: 'app-mypage-component',
	templateUrl: './MyPageFragmentComponent.html',
	styleUrls: ['./MyPageFragmentComponent.scss'],
})
export class MyPageFragmentComponent extends BaseFragment {

	// イベント設定
	private TARGET_CLASS_DEF = AppViewReceiverConst.User.Fragment.MyPageFragmentComponent;
	protected EVENT_LIST: Array<Array<any>> = [
		// 画面遷移用イベント。BaseFragmentに実装されているメソッドなので注意
		// スライドイン呼び出し
		[
			this.TARGET_CLASS_DEF,
			this.TARGET_CLASS_DEF.ChangeMovePanelView,
			this.changeMovePanelView.bind(this)
		],
		// スライドインした時に消えた前パネルを戻す
		[
			this.TARGET_CLASS_DEF,
			this.TARGET_CLASS_DEF.VisiblePanelView,
			this.visibleAllViewRef.bind(this)
		],
		// スライドインを閉じる
		[
			this.TARGET_CLASS_DEF,
			this.TARGET_CLASS_DEF.CloseMovePanelView,
			this.closeMovePanelView.bind(this)
		]
	];

	// スライドイン用のコンポーネント
	@ViewChild('slideMoveBaseContainer', { read: ViewContainerRef, static: false })
	public slideMoveBaseRef: ViewContainerRef;

	/**
	 * constructor
	 */
	constructor() {

		// Angulerのコンポーネントなので、上位を呼ぶ必要がある
		super();

		// EVENT_LISTに定義したイベントを登録する。
		this.registerEvent();
	}

	/**
	 * 開始処理
	 */
	public async start() {

		// スワイプでロケーションバックを非活性にする
		this.disablePhoneSwipeBack();

	}

	/////////////////////////////////////
	// 画面イベント
	/**
	 * onClickShowUserInfoPanel
	 * ユーザー情報表示ボタンを押下したときのイベント
	 */
	public async onClickShowUserInfoPanel() {

		// スライドインで表示する。
		const inst = await this.changeMovePanelView(this, UserInfoPanelComponent) as UserInfoPanelComponent;

		// 作ったインスタンスに、アニメーションコールバック用のモデルをセット
		const targetDomain = AppViewReceiverConst.User.Fragment;
		const targetName = targetDomain.MyPageFragmentComponent;
		const eventTargetModel = new AppViewReceiverModel(targetDomain, targetName, targetName.ChangeMovePanelView, this);
		inst.animationParentEventModel = eventTargetModel;

	}


	/**
	 * onClickShowSocialLinkSettingPanel
	 * ライン連携設定表示ボタンを謳歌したときのイベント
	 */
	public async onClickShowSocialLinkSettingPanel() {

		// スライドインで表示する。
		const inst = await this.changeMovePanelView(this, SocialLinkSettingPanelComponent) as SocialLinkSettingPanelComponent;

		// 作ったインスタンスに、アニメーションコールバック用のモデルをセット
		const targetDomain = AppViewReceiverConst.User.Fragment;
		const targetName = targetDomain.MyPageFragmentComponent;
		const eventTargetModel = new AppViewReceiverModel(targetDomain, targetName, targetName.ChangeMovePanelView, this);
		inst.animationParentEventModel = eventTargetModel;

	}

	/**
	 * onClickShowPasswordSettingPanel
	 * ライン連携設定表示ボタンを謳歌したときのイベント
	 */
	 public async onClickShowPasswordSettingPanel() {

		// スライドインで表示する。
		const inst = await this.changeMovePanelView(this, PasswordResettingPanelComponent) as PasswordResettingPanelComponent;

		// 作ったインスタンスに、アニメーションコールバック用のモデルをセット
		const targetDomain = AppViewReceiverConst.User.Fragment;
		const targetName = targetDomain.MyPageFragmentComponent;
		const eventTargetModel = new AppViewReceiverModel(targetDomain, targetName, targetName.ChangeMovePanelView, this);
		inst.animationParentEventModel = eventTargetModel;

	 }

	/**
	 * onClickShowHealthInsureSettingPanel
	 * 保険証アップロード表示ボタンを謳歌したときのイベント
	 */
	public async onClickShowHealthInsureSettingPanel() {

		// スライドインで表示する。
		const inst = await this.changeMovePanelView(this, HealthInsureSettingPanelComponent) as HealthInsureSettingPanelComponent;

		// 作ったインスタンスに、アニメーションコールバック用のモデルをセット
		const targetDomain = AppViewReceiverConst.User.Fragment;
		const targetName = targetDomain.MyPageFragmentComponent;
		const eventTargetModel = new AppViewReceiverModel(targetDomain, targetName, targetName.ChangeMovePanelView, this);
		inst.animationParentEventModel = eventTargetModel;

	}


}
